import React from 'react';
export default function UnknownBlock(props) {
    return React.createElement("div", { className: "UnknownBlock" }, props.children);
}
//# sourceMappingURL=unknownBlock.js.map